<p><!-- Transport Pickups Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Transport Pickups Management</h3>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-table-toolbar="base">
        <!--begin::Send Mail (Bulk)-->
        <button type="button" class="btn btn-sm btn-success fw-bold d-flex me-3"
                *ngIf="hasSelectedTransportPickups" (click)="sendBulkMail()" [disabled]="isSendingMail">
          <span *ngIf="isSendingMail" class="spinner-border spinner-border-sm me-2" role="status">
            <span class="visually-hidden">Loading...</span>
          </span>
          <i *ngIf="!isSendingMail" class="ki-duotone ki-sms fs-6 me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>{{ isSendingMail ? 'Sending...' : 'Send Mail (' + selectedTransportPickups.size + ')' }}</span>
        </button>
        <!--end::Send Mail (Bulk)-->
        <button type="button" class="btn btn-sm btn-dark fw-bold d-flex me-3"
          [class.active]="showFilters"
          (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Filter</span>
        </button>
        <button type="button" class="btn btn-sm btn-dark me-3 text-nowrap" (click)="openAddTransportPickupModal()">
          <i class="ki-duotone ki-plus fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Add Transport Pickup</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="card-body border-bottom py-4 transport-pickup-filters" *ngIf="showFilters" [@slideInOut]>
    <div class="row g-4">
      <!-- Keyword -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Keyword</label>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Enter keyword..."
          [(ngModel)]="filters.keyword">
      </div>

      <!-- Stock Number -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Stock Number</label>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Enter stock number..."
          [(ngModel)]="filters.stock_number">
      </div>

      <!-- Order Date From -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Order Date From</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.order_date_from">
      </div>

      <!-- Order Date To -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Order Date To</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.order_date_to">
      </div>
    </div>

    <div class="row g-4 mt-2">
      <!-- Cut Date From -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Cut Date From</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.cut_date_from">
      </div>

      <!-- Cut Date To -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Cut Date To</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.cut_date_to">
      </div>

      <!-- Yard In Date From -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Yard In Date From</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.yard_in_date_from">
      </div>

      <!-- Yard In Date To -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Yard In Date To</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.yard_in_date_to">
      </div>
    </div>

    <div class="row g-4 mt-2">
      <!-- Yard Out Date From -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Yard Out Date From</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.yard_out_date_from">
      </div>

      <!-- Yard Out Date To -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Yard Out Date To</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.yard_out_date_to">
      </div>

      <!-- Filter Actions -->
      <div class="col-md-6 d-flex align-items-end justify-content-end">
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-sm btn-danger" (click)="applyFilters()">
            <i class="ki-duotone ki-magnifier fs-3">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Apply Filters
          </button>
          <button type="button" class="btn btn-sm btn-secondary" (click)="resetFilters()">
            <i class="ki-duotone ki-cross fs-3">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Transport Pickups Table -->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="w-10px pe-2">
              <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                <input class="form-check-input" type="checkbox"
                       [checked]="selectAll"
                       (change)="toggleSelectAll()"
                       data-kt-check="true"
                       data-kt-check-target=".widget-13-check">
              </div>
            </th>
            <th class="min-w-100px">Stock (Plate No.)</th>
            <th class="min-w-100px">Lot Number</th>
            <th class="min-w-100px">Chassis No</th>
            <th class="min-w-120px">Pick From</th>
            <th class="min-w-120px">Delivery At</th>
            <th class="min-w-100px">Pos No</th>
            <th class="min-w-100px">Order Date <br/> Out Date</th>
            <th class="min-w-100px">Yard In Date <br/> Yard Out Date</th>
            <th class="min-w-100px">Transport Company</th>
            <th class="min-w-150px">Admin Comments</th>
            <th class="min-w-150px">Transport Comments</th>

<!--
            <th class="min-w-100px">Pickup Date</th>
            <th class="min-w-120px">Shipper</th>
            <th class="min-w-150px">Consignee/Transporter</th>
            <th class="min-w-100px">Delivery Date</th> -->
            <th class="min-w-100px text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading State -->
          <tr *ngIf="isLoading">
            <td colspan="13" class="text-center py-5">
              <div class="d-flex justify-content-center align-items-center">
                <span class="spinner-border spinner-border-sm me-2"></span>
                Loading transport pickups...
              </div>
            </td>
          </tr>

          <!-- No Data State -->
          <tr *ngIf="!isLoading && transportPickups.length === 0">
            <td colspan="13" class="text-center py-5">
              <div class="text-muted">No transport pickups found</div>
            </td>
          </tr>

          <!-- Data Rows -->
          <tr *ngFor="let transportPickup of transportPickups; trackBy: trackByFn">
            <td class="text-center pe-0">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input widget-13-check"
                  type="checkbox"
                  [value]="transportPickup._id || transportPickup.id"
                  [checked]="isTransportPickupSelected(transportPickup._id || transportPickup.id)"
                  (change)="toggleTransportPickupSelection(transportPickup._id || transportPickup.id)">
              </div>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ transportPickup.vehicle?.car_no || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ transportPickup.vehicle?.inventory_no || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ transportPickup.vehicle?.vin_no || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ transportPickup.pickup_from || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ transportPickup.delivered_at || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ transportPickup.pos_no || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ transportPickup.order_date || '-' }} <br/>
                {{ transportPickup.out_date || '-' }}

              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ transportPickup.yard_in || '-' }} <br/>
                {{ transportPickup.yard_out || '-' }}

              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ transportPickup.transport_company_name || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ transportPickup.admin_comment || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ transportPickup.comment_for_transporter || '-' }}
              </span>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Send Mail Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-success"
                  (click)="sendSingleMail(transportPickup)"
                  [disabled]="isSendingMail"
                  title="Send Mail">
                  <span *ngIf="isSendingMail" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </span>
                  <i *ngIf="!isSendingMail" class="ki-duotone ki-sms fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Edit Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditTransportPickupModal(transportPickup)"
                  title="Edit Transport Pickup">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-danger"
                  (click)="deleteTransportPickup(transportPickup)"
                  title="Delete Transport Pickup">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <app-pagination
      *ngIf="!isLoading && transportPickups.length > 0"
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>
